import replace from 'lodash/replace';

export const formatReplaceNumber = (price: string): string => {
  let formattedNumber = price;

  formattedNumber = replace(formattedNumber, ',00', '');
  formattedNumber = replace(formattedNumber, '.00', '');

  return formattedNumber;
};
